import React from 'react';
import cs from 'classnames';
import DocumentTitle from 'react-document-title';
import {Helmet} from 'react-helmet';
import {connect} from 'react-redux';
import {push as pushPath} from 'react-router-redux';

import * as urls from '~/routing/urls';
// import {getBrokerName, getBrokerDescName, resource} from '~/misc/brokers';
import mapDispatch from '~/misc/mapDispatch';
import {removeCompany} from '~/modules/myCompany/actions';

import css from './index.css';

const navigate = (props, e) => pushPath(e.currentTarget.getAttribute('href'));
// MYCOMPANY
const BrokerItem = ({DOT, id, brokerId, company, type, view, myCompany, removeCompany}) => {
  // const descName = getBrokerDescName(brokersData, DOT);
  const descName = null;
  const url = `${urls.MYCOMPANY}/${id}`;
  const viewLoads = (e) => {
    e.preventDefault();
    if (myCompany === 'saved') {
      view(e);
    }
  };
  const remove = (e) => {
    e.stopPropagation();
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    removeCompany({id: brokerId, company, type});
  };
  return (
    <div>
      <a className={cs(css.brokerItem, myCompany !== 'saved' && css.clickable)} href={url} onClick={viewLoads}>
        <span className={css.codeName}>{id ? id : '--'}</span>{' '}
        <span className={css.link}>

          {DOT.broker_name ? DOT.broker_name : '--'}
          {descName ? <span className={css.descName}>{descName}</span> : null}
        </span>
        <span className={cs(css.remove)}>
          <button className={cs(css.removeButton)} onClick={remove}>Remove</button>
        </span>
      </a>
      <a className={cs(css.mobileBrokerItem, myCompany !== 'saved' && css.clickable)} href={url} onClick={viewLoads}>
        <div className={cs(css.mobileBrokerTop)}>
          <span className={css.mobileCodeName}>{id ? id : '--'}</span>{' '}
          <button className={cs(css.mobileRemoveButton)} onClick={remove}>Remove</button>
        </div>
        <div className={cs(css.mobileBrokerBottom)}>
          {DOT.broker_name ? DOT.broker_name : '--'}
          {descName ? <span className={css.mobileDescName}>{descName}</span> : null}
        </div>
      </a>
    </div>);
};

const BrokersCatalog = ({brokersData, type, view, myCompany, removeCompany}) => (
  <div className={cs(css.page)}>
    <Helmet>
      <meta
        name='description'
        content={'Find brokers to haul loads from'}
      />
    </Helmet>
    <div className={cs(css.list, myCompany !== 'saved' && css.clickable)}>
      {brokersData.map(DOT => (<BrokerItem
        key={DOT.broker_id}
        id={DOT.broker_dot}
        brokerId={DOT.broker_id}
        company={DOT.broker_name}
        DOT={DOT}
        type={type}
        view={view}
        myCompany={myCompany}
        removeCompany={removeCompany}
      />)
      )}
    </div>

  </div>
);

export default connect((state, {type}) => {
  const data = state.myCompany[type];
  const myCompany = state.tabs.myCompany ? state.tabs.myCompany : 'saved';
  return {
    brokersData: data || [],
    myCompany: myCompany,
    type: type,
  };
}, mapDispatch({
  view: navigate,
  removeCompany: (props, data) => removeCompany(data),
}))(BrokersCatalog);



// WEBPACK FOOTER //
// ./src/components/pages/MyCompany/BrokersCatalog/index.js